var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmployees({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.43914 9.24962C12.0537 9.24962 14.1733 7.17902 14.1733 4.62481C14.1733 2.0706 12.0537 0 9.43914 0C6.82454 0 4.70499 2.0706 4.70499 4.62481C4.70499 7.17902 6.82454 9.24962 9.43914 9.24962Z",
    fill: "#FFFFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.07603 19.1363V21.2841C8.07603 21.4739 8.15324 21.656 8.29067 21.7903C8.42811 21.9245 8.61451 22 8.80887 22H21.2672C21.4615 22 21.6479 21.9245 21.7854 21.7903C21.9228 21.656 22 21.4739 22 21.2841V14.1249C22 13.935 21.9228 13.7529 21.7854 13.6187C21.6479 13.4844 21.4615 13.409 21.2672 13.409H16.1373V12.3566C16.1373 12.1667 16.0601 11.9846 15.9226 11.8504C15.7852 11.7161 15.5988 11.6407 15.4044 11.6407C15.2101 11.6407 15.0237 11.7161 14.8862 11.8504C14.7488 11.9846 14.6716 12.1667 14.6716 12.3566V13.409H13.2059V10.846C11.9606 10.6473 10.7009 10.5468 9.43911 10.5453C6.65637 10.5338 3.90481 11.1178 1.37787 12.2564C0.961968 12.4481 0.611101 12.7524 0.366896 13.1331C0.122692 13.5137 -0.00459923 13.9549 0.000126986 14.4041V19.1363H8.07603ZM20.5343 20.5681H9.54171V14.8408H14.6716V15.1415C14.6716 15.3314 14.7488 15.5135 14.8862 15.6477C15.0237 15.782 15.2101 15.8574 15.4044 15.8574C15.5988 15.8574 15.7852 15.782 15.9226 15.6477C16.0601 15.5135 16.1373 15.3314 16.1373 15.1415V14.8408H20.5343V20.5681Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployees);
export default __webpack_public_path__ + "static/media/employees.055fc183336f5d5f6bfbdd3e7a4ab60f.svg";
export { ForwardRef as ReactComponent };